const initialState = {
    isOpen: false,
    isActive: false,
    email: '', 
    emailErr: '',
};
const modalEditEmail = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_MODAL_EDIT_EMAIL':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default modalEditEmail;
